"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnusedSideZone = exports.OneSidedGradient = exports.Zone = void 0;
/*
 * © 2026 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
/** Rectangle covering the full height of the graphic; just supply the x-coordinates of the two ends and the fill */
const Zone = ({ x1, x2, height, fill, opacity = 1 }) => (react_1.default.createElement("rect", { x: Math.min(x1, x2), width: Math.abs(x2 - x1), height: height, fill: fill, opacity: opacity, shapeRendering: "crispEdges" }));
exports.Zone = Zone;
/** SVG gradient definition for hatching out the unused side of a single-sided tolerance graphic; render inside a <defs> */
const OneSidedGradient = ({ id, direction }) => direction === "none" || direction === "double" ? null : (react_1.default.createElement("linearGradient", { id: id, x2: "3px", y2: "3px", spreadMethod: "repeat", gradientUnits: "userSpaceOnUse" },
    react_1.default.createElement("stop", { stopColor: "#FFF0", offset: "65%" }),
    react_1.default.createElement("stop", { stopColor: "#FFF3", offset: "68%" }),
    react_1.default.createElement("stop", { stopColor: "#FFF3", offset: "97%" }),
    react_1.default.createElement("stop", { stopColor: "#FFF0", offset: "100%" })));
exports.OneSidedGradient = OneSidedGradient;
/** Hatched shading over the side of a single-sided tolerance graphic that has no limit */
const UnusedSideZone = ({ direction, width, height, gradientId }) => {
    if (direction === "none" || direction === "double")
        return null;
    return (react_1.default.createElement(exports.Zone, { fill: `url(#${gradientId})`, x1: direction === "single negative" ? width : 0, x2: width / 2, height: height }));
};
exports.UnusedSideZone = UnusedSideZone;
//# sourceMappingURL=ToleranceZones.js.map